import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AuthRedirect({ children }) {
  const { user, loading } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      nav("/home");
    }
  }, [user, loading, nav]);

  if (loading) return <div>Loading...</div>;

  return children;
}